module.exports = __webpack_public_path__ + "static/img/company-qrcode.4bd41c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/company-qrcode.png
// module id = G7uo
// module chunks = 1